<template>
<div id="container" class="container impressum">
  <top-menu />
  <top-logo />
  <stoppuhr />
  <lautsprecher />
  <copyright />
  <div class="fullscreen_background">
    <img src="/static/assets/veranstaltungen/Hintergrund_2860.jpg" />
  </div>
  <div class="content">
    <div class="inner">
     <!-- <div class="ueberschrift">Elterninfo</div>-->
      <vuescrollbar class="content_text">
        <h1>Die Hugidubies Abenteuer machen Kindern Lust aufs Lesen.</h1>
<h2>Spannende Kindergeschichten, die zum Vorlesen und Selberlesen einladen.</h2>
<p>Die Kindergeschichten der Hugidubies können Leseanfänger selbst lesen und dabei auch hören. Für die Leseanfänger haben wir eigens eine Lesehilfe eingebaut, die jedes gerade zu hörende Wort im Lesetext rot unterlegt. So können sie die Kindergeschichten Wort für Wort mitverfolgen. Natürlich sind die kostenlosen Kindergeschichten zum Vorlesen ebenso geeignet.</p>
<p>Ahoi! In unserer Piratengeschichte für Kinder stechen die Hugidubies unter Kapitänin Gigi in See, bändigen ein Seeungeheuer und finden mit seiner Hilfe einen wertvollen Schatz.<br /><br />Werfen Sie Anker zur Piratengeschichte für Kinder: <a href="#/piratengeschichten" title="Hier finden Sie eine Piratengeschichte zum Vorlesen für Kinder, auch als kostenloses Hörbuch" alt="Hier finden Sie eine Piratengeschichte zum Vorlesen für Kinder, auch als kostenloses Hörbuch">Gigi Käpt´n Ahoi</a></p>
<p>Es war einmal… So beginnt auch unser Märchen für Kinder, in dem eine wunderschöne Prinzessin von einer bösen Zauberin verhext wird. Wer und was kann die Prinzessin wiedererwecken?<br /><br />Lassen Sie sich entführen ins Land der Märchen für Kinder: <a href="#/maerchengeschichten" title="Hier finden Sie ein Märchen zum Vorlesen für Kinder, auch als kostenloses Hörbuch" alt="Hier finden Sie ein Märchen zum Vorlesen für Kinder, auch als kostenloses Hörbuch">Der kluge Prinz Hugi</a></p>
<p>Hex, Hugidubie, große Magie! Das ist der rettende Zauberspruch in unserer Kindergeschichte mit Zauberern. Gut, dass Hexenmeister Dubix ihn kennt und weiß, wie man einen Verschwindezauber rückgängig machen kann.<br /><br />Unsere Zauberergeschichte für Kinder wird Sie in Bann ziehen: <a href="#/zaubergeschichten" title="Hier finden Sie eine Geschichte über Zauberer zum Vorlesen für Kinder, auch als kostenloses Hörbuch" alt="Hier finden Sie eine Geschichte über Zauberer zum Vorlesen für Kinder, auch als kostenloses Hörbuch">Zaubermeister Dubix</a></p>
<p>Artisten, Clowns und Sensationen! Unsere Zirkus-Geschichte für Kinder führt in das große bunte Zirkuszelt, wo gelacht und gestaunt werden darf. Werden die Akrobaten das ganz große Kunststück schaffen?<br /><br />Manege frei für unsere Zirkusgeschichte für Kinder: <a href="#/zirkusgeschichten" title="Hier finden Sie eine Zirkusgeschichte zum Vorlesen für Kinder, auch als kostenloses Hörbuch" alt="Hier finden Sie eine Zirkusgeschichte zum Vorlesen für Kinder, auch als kostenloses Hörbuch">Zirkusdirektor Dubix</a></p>
<p>Die Heydubies auf der Bühne und schon rockt der Saal in unserer Kindergeschichte übers Tanzen. Doch zuvor muss Cool DJ Hugi ein Problem lösen und seiner Bandkollegin das Lampenfieber nehmen.<br /><br />Spotlights on für unsere Tanzgeschichte für Kinder: <a href="#/djgeschichten" title="Hier finden Sie eine Kindergeschichte übers Tanzen zum Vorlesen für Kinder, auch als kostenloses Hörbuch" alt="Hier finden Sie eine Kindergeschichte übers Tanzen zum Vorlesen für Kinder, auch als kostenloses Hörbuch">Cool DJ Hugi</a></p>
<p>Skiheil! In unserer Wintergeschichte für Kinder sind die Hugidubies voll im Pistenglück, bis starker Schneefall sie zur Rückkehr in ihre Hütte zwingt. Es will aber nicht aufhören zu schneien und die Hugidubies müssen sehen, wie sie in ihrer eingeschneiten Hütte zurechtkommen.<br /><br />Erleben Sie spannenden Hüttenzauber in unser Wintergeschichte für Kinder: <a href="#/skigeschichten" title="Hier finden Sie eine Winterschneegeschichte zum Vorlesen für Kinder, auch als kostenloses Hörbuch" alt="Hier finden Sie eine Winterschneegeschichte zum Vorlesen für Kinder, auch als kostenloses Hörbuch">Gold Gigi</a></p>
<h1>Die Kinder-Malbögen online machen die Hugidubies-Welt noch bunter!</h1>
<h2>Ausmalbilder für Kleinkinder, die Sie kostenlos zum Ausdrucken herunterladen können.</h2>
<p>Auf der Hugidubies-Website können Ihre Kleinen die kostenlosen Kindergeschichten der Hugidubies nicht nur selbst kennenlernen, sondern auch in Ausmalbildern zum Ausdrucken weiterspinnen und mit ihren Kreationen bereichern.</p>
<p>Käpt´n Gigi ist die Herrin der Sieben Meere und wartet auf eine besonders schicke Kapitänsuniform.<br /><br />Den kostenlosen Kinder-Malbogen finden Sie online hier: <a href="/static/assets/alle/Hudu_Hugidubies_Piraten_LY_Gigi.pdf" target="_blank" title="Hier finden Sie online einen kostenlosen Malbogen für Kinder und Kleinkinder zum Ausdrucken" alt="Hier finden Sie online einen kostenlosen Malbogen für Kinder und Kleinkinder zum Ausdrucken">Käpt´n Gigi Kindermalbogen</a></p>
<p>Er ist ein großer Zaubermeister und nicht nur sein Zauberstab will individuell gestaltet werden.<br /><br />Das Ausmalbild für Kinder und Kleinkinder zum Ausdrucken finden Sie hier: <a href="/static/assets/alle/Hudu_Hugidubies_Zauberer_Dubix.pdf" target="_blank" title="Hier finden Sie online einen kostenlosen Malbogen für Kinder und Kleinkinder zum Ausdrucken" alt="Hier finden Sie online einen kostenlosen Malbogen für Kinder und Kleinkinder zum Ausdrucken">Hexenmeister Dubix Kindermalbogen</a></p>
<p>Er ist lieb und klug, doch das Outfit von Prinz Hugi sollte dringend farbenprächtiger werden.<br /><br />Den kostenlosen Kinder-Malbogen finden Sie online hier: <a href="/static/assets/alle/Hudu_Hugidubies_Maerchen_Hugi.pdf" target="_blank" title="Hier finden Sie online einen kostenlosen Malbogen für Kinder und Kleinkinder zum Ausdrucken" alt="Hier finden Sie online einen kostenlosen Malbogen für Kinder und Kleinkinder zum Ausdrucken">Der kluge Prinz Hugi Kindermalbogen</a></p>
<p>Als seine Prinzessin verzaubert wurde, konnte er kein Feuer mehr spucken. Doch jetzt ist Hausdrache Libero wieder glücklich und freut sich auf kreative Kinder.<br /><br />Das Ausmalbild für Kinder und Kleinkinder zum Ausdrucken finden Sie hier: <a href="/static/assets/alle/Hudu_Hugidubies_Maerchen_Libero.pdf" target="_blank" title="Hier finden Sie online einen kostenlosen Malbogen für Kinder und Kleinkinder zum Ausdrucken" alt="Hier finden Sie online einen kostenlosen Malbogen für Kinder und Kleinkinder zum Ausdrucken">Hausdrache Libero Kindermalbogen</a></p>
<p>Gold Gigi ist eine super Skifahrerin. Damit sie auf der Piste gut gesehen wird, muss ihr Skianzug möglichst farbig sein.<br /><br />Den kostenlosen Kinder-Malbogen finden Sie online hier: <a href="/static/assets/alle/Hudu_Hugidubies_Ausmalbilder_0512_Gigi.pdf" target="_blank" title="Hier finden Sie online einen kostenlosen Malbogen für Kinder und Kleinkinder zum Ausdrucken" alt="Hier finden Sie online einen kostenlosen Malbogen für Kinder und Kleinkinder zum Ausdrucken">Gold Gigi Kindermalbogen</a></p>    
<p>Der Zirkus ist eine bunte Glitzerwelt. Zirkusdirektor Dubix will da mithalten können.<br /><br />Das Ausmalbild für Kinder und Kleinkinder zum Ausdrucken finden Sie hier: <a href="/static/assets/alle/Hudu_Hugidubies_Ausmalbilder_0512_Dubix.pdf" target="_blank" title="Hier finden Sie online einen kostenlosen Malbogen für Kinder und Kleinkinder zum Ausdrucken" alt="Hier finden Sie online einen kostenlosen Malbogen für Kinder und Kleinkinder zum Ausdrucken">Zirkusdirektor Dubix Kindermalbogen</a></p>      
<p>DJ Hugi liebt die vielen Farben der Spotlights und sein Outfit soll genauso leuchten.<br /><br />Den kostenlosen Kinder-Malbogen finden Sie online hier: <a href="/static/assets/alle/Hudu_Hugidubies_Ausmalbilder_0512_Hugi.pdf" target="_blank" title="Hier finden Sie online einen kostenlosen Malbogen für Kinder und Kleinkinder zum Ausdrucken" alt="Hier finden Sie online einen kostenlosen Malbogen für Kinder und Kleinkinder zum Ausdrucken">Der DJ Hugi Kindermalbogen</a></p>   
<p>Hüttenhund Libero mag das Weiß des Schnees sehr, ansonsten kann es ihm nicht bunt genug zugehen.<br /><br />Das Ausmalbild für Kinder und Kleinkinder zum Ausdrucken finden Sie hier: <a href="/static/assets/alle/Hudu_Hugidubies_Ausmalbilder_0512_Libero.pdf" target="_blank" title="Hier finden Sie online einen kostenlosen Malbogen für Kinder und Kleinkinder zum Ausdrucken" alt="Hier finden Sie online einen kostenlosen Malbogen für Kinder und Kleinkinder zum Ausdrucken">Hüttenhund Libero Kindermalbogen</a></p>
<p>Auf der Hugidubies-Website können Ihre Kleinen die kostenlosen Kindergeschichten der Hugidubies nicht nur selbst kennenlernen, sondern auch in Ausmalbildern zum Ausdrucken weiterspinnen und mit ihren Kreationen bereichern.</p>        
<h1>Die Hugidubies sorgen auch online für wertvolle Kinder-Beschäftigung.</h1>
<h2>Kostenlose Online-Kinderspiele, die schon Kleinkindern ab 3 Jahren und Kindergartenkindern Spaß machen.</h2>
<p>In diesem lustigen und kostenlosen Online-Kinderspiel zeigen sich die Hugidubies in ihren verschiedenen Rollen. Wer findet die identischen Pärchen? Diese Kinder-Beschäftigung fördert die Konzentration und trainiert das Gedächtnis. Hier dürfen sich auch schon Kleinkinder online beschäftigen, denn das gratis Online-Kinderspiel ab 3 Jahren gibt es in drei verschiedenen Schwierigkeitsgraden, Kindergartenkinder wie Schulkinder werden ihre Freude daran haben.</p>
<p>So viele Abenteuer, so viele Hugidubies-Rollen. Spielen Sie das <a href="#/spielememory" title="Hier finden Sie eine Kinder-Beschäftigung, ein kostenloses Online-Kinderspiel ab 3 Jahren, mit denen sich Kinder und Kleinkinder online beschäftigen" alt="Hier finden Sie eine Kinder-Beschäftigung, ein kostenloses Online-Kinderspiel ab 3 Jahren, mit denen sich Kinder und Kleinkinder online beschäftigen">Hugidubies-Memo</a></p>
<p>Allen Kindern viel Spaß in der bunten Welt der Hugidubies!</p>
      </vuescrollbar>
      </div>
    </div>
</div>
</template>

<script>
/* eslint-disable */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
import VueScrollBar from 'vue-perfect-scrollbar'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'impressum',
  data () {
    return {
      who: 'impressum'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'vuescrollbar': VueScrollBar
  },
  mounted () {
    this.$ga.page(this.$router)
  }
}
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

/* Z-Index - Level */

.z1 {
  z-index: 10;
}

.z2 {
  z-index: 20;
}

.z3 {
  z-index: 30;
}

.z4 {
  z-index: 40;
}

.z5 {
  z-index: 50;
}

.z6 {
  z-index: 60;
}

.z7 {
  z-index: 70;
}

.z8 {
  z-index: 80;
}

.z9 {
  z-index: 90;
}

.z10 {
  z-index: 100;
}

.z11 {
  z-index: 110;
}

.z12 {
  z-index: 120;
}

.z13 {
  z-index: 130;
}

.z14 {
  z-index: 140;
}

.z15 {
  z-index: 150;
}

.z16 {
  z-index: 160;
}

.z17 {
  z-index: 170;
}

.z18 {
  z-index: 180;
}

.z19 {
  z-index: 190;
}

.z20 {
  z-index: 200;
}

.z21 {
  z-index: 210;
}

.z22 {
  z-index: 220;
}

.z23 {
  z-index: 230;
}

.z24 {
  z-index: 240;
}

.z25 {
  z-index: 250;
}

.z26 {
  z-index: 260;
}

.z27 {
  z-index: 270;
}

.z28 {
  z-index: 280;
}

.z29 {
  z-index: 290;
}

.z30 {
  z-index: 300;
}

.z31 {
  z-index: 310;
}

.z32 {
  z-index: 320;
}

.z33 {
  z-index: 330;
}

.z34 {
  z-index: 340;
}

.z35 {
  z-index: 350;
}

.z36 {
  z-index: 360;
}

.z37 {
  z-index: 370;
}

.z38 {
  z-index: 380;
}

.z39 {
  z-index: 390;
}

.z40 {
  z-index: 400;
}

.z41 {
  z-index: 410;
}

.z42 {
  z-index: 420;
}

.z43 {
  z-index: 430;
}

.z44 {
  z-index: 440;
}

.z45 {
  z-index: 450;
}

.z46 {
  z-index: 460;
}

.z47 {
  z-index: 470;
}

.z48 {
  z-index: 480;
}

.z49 {
  z-index: 490;
}

.z50 {
  z-index: 500;
}

.impressum .himmel {
  position: absolute;
  top: 0px;
  left: 0;
  width: 100%;
  height: auto;
}

.impressum .content {
position: absolute;
    top: 318px;
    left: 330px;
    width: 80%;
    height: 500px;
    font-size: 16pt;
    font-family: 'Open Sans';
    font-weight: 400;
}

.impressum .content .inner {
  position: relative;
}

.impressum .content .inner .ueberschrift {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  color: white;
  font-family: FrozenMemory;
  font-size: 36px;
}

.impressum .content .inner .content_text {
  position: absolute;
  top: 50px;
  left: 0;
  width: 1200px;
  height: 530px;
  /*overflow-y: scroll;*/
  padding-right: 25px;
}
  h1{
    font-family: FrozenMemory;
    font-size: 40px;
    /*color: #e63100; */
    color: #FFFFFF;
}
h2 {
    /* font-family: FrozenMemory; */
    font-size: 30px;
  margin-top: -30px;
    /* color: #e63100; */
}
a {
    color: #FFFFFF;
    text-decoration: none;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Elterninfo_zusatz.vue